import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './WizardCard.styles';

export interface WizardCardProps {
  /** Основное изображение карточки */
  mainImage: string;
  /** Изображение с номером шага */
  stepImage: string;
  /** Ключ для перевода заголовка */
  titleKey: string;
  /** Ключ для перевода описания */
  descriptionKey: string;
  /** Цветовая схема карточки */
  colorScheme: {
    /** Основной цвет границы */
    borderColor: string;
    /** Цвет заголовка */
    titleColor: string;
    /** Градиент для верхней полоски */
    gradientColors: [string, string];
    /** Градиент фона карточки */
    backgroundGradient: [string, string];
  };
  /** Позиция карточки в орбите (в градусах) */
  rotation: number;
  /** Радиус орбиты */
  orbitRadius?: number;
  /** Ширина карточки */
  width?: number;
  /** Функция обратного вызова при клике */
  onClick?: () => void;
  /** Дополнительные стили */
  style?: React.CSSProperties;
}

const WizardCard: React.FC<WizardCardProps> = ({
  mainImage,
  stepImage,
  titleKey,
  descriptionKey,
  colorScheme,
  rotation,
  orbitRadius = 240,
  width = 220,
  onClick,
  style = {}
}) => {
  const { t } = useTranslation();

  return (
    <S.CardContainer
      rotation={rotation}
      orbitRadius={orbitRadius}
      width={width}
      onClick={onClick}
      style={style}
    >
      <S.StyledCard colorScheme={colorScheme}>
        <S.TopColorBar colorScheme={colorScheme} />
        
        <S.ImageContainer>
          <S.MainImage src={mainImage} preview={false} />
          <S.StepImage src={stepImage} preview={false} />
        </S.ImageContainer>

        <S.TextContainer>
          <S.CardTitle colorScheme={colorScheme}>
            {t(titleKey)}
          </S.CardTitle>

          <S.CardDescription>
            {t(descriptionKey)}
          </S.CardDescription>
        </S.TextContainer>
      </S.StyledCard>
    </S.CardContainer>
  );
};

export default WizardCard;
